export default "__VITE_ASSET__081a519e__"